import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React, { createContext, useContext, useMemo } from "react";
//Limitless imports
import { useNotifications } from "./NotificationHook"; // Set the default state values for each context

export var NotificationContext = createContext({});
export var NotificationContextProvider = function NotificationContextProvider(_ref) {
  var children = _ref.children;
  var notifications = useNotifications();
  var notificationContext = useMemo(function () {
    return _objectSpread({}, notifications);
  }, [notifications.notification]);
  return /*#__PURE__*/React.createElement(NotificationContext.Provider, {
    value: notificationContext
  }, children);
};
export var useNotificationContext = function useNotificationContext() {
  return useContext(NotificationContext);
};